export const FIND_REPORTS_FAILURE = 'FIND_REPORTS_FAILURE';

export const findReportsFailure = ({ error, request }) => ({
    type: FIND_REPORTS_FAILURE,
    payload: error,
    error: true,
    meta: {
        request
    }
});